import { put, takeLatest, call } from 'redux-saga/effects';

import {
  getHubHomeSuccess,
} from '../actionCreators/homeHubActions';
import { GET_HOME_HUB_REQUEST } from '../constants/actionTypes';
import { HomeHubApi } from '../api';
import errorHandler from '../utils/requestErrorHandler';

function* getHomeHub(action) {
  try { 
    const data = yield call(HomeHubApi.getHomeHub, action.payload);

    yield put(getHubHomeSuccess(data));
  } catch (error) {
    yield errorHandler(error);
  }
}

export default function* watchChallenge() {
  yield takeLatest(GET_HOME_HUB_REQUEST, getHomeHub);
}
